import request from '@/utils/request'

export function getAliYunSts() {
    return request({
        url: '/file/ali/getsts',
        method: 'get'
    })
}
